import { Field } from '@/components/Form';
import { Patient } from '@/types/database';
import { capitalize, Dict } from '@ajorquera/libs/utils';

export const mergeValuesIntoFields = (values: Dict<string>, fields: Field[]) => {
  return fields.map((field) => {
    if (field.name && values) {
      const value = values[field.name] ?? field.value;
      return {
        ...field,
        value,
      };
    }

    return field;
  });
};

export const createTimeoutPromise = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
};

export const capitalizeStr = (str: string) => {
  if (typeof str !== 'string') return str;
  return str.split('-').map(capitalize).join('');
};

export const hasDateExpire = (date: Date) => {
  return Number(date) <= Date.now();
};

export const getLabelStatus = (status?: Patient['status']) => {
  switch (status) {
    case 'pending-patient':
      return 'Awaiting patient';
    case 'submitted':
      return 'Submitted by patient';
    case 'reviewed':
      return 'Reviewed';
    case 'come-to-clinic':
      return 'Come to clinic';
    case 'cant-be-performed':
      return 'Can\'t be performed';
    case 'active':
      return '';
    case 'archived':
      return 'Archived';

    default:
      return '';
  }
};

export const getLabelColor = (status?: Patient['status']) => {
  switch (status) {
    case 'pending-patient':
      return 'warning';
    case 'submitted':
      return 'info';
    case 'reviewed':
      return 'success';
    
    case 'active':
      return 'default';
    case 'come-to-clinic':
    case 'cant-be-performed':
      return 'error';
    case 'archived':
    default:
      return 'default';
  }
};

type OGTags = Record<'title' | 'type' | 'url' | 'image' | 'description' | 'favicon', string>;

export const createOpenGraphTags = (tags: OGTags) => {
  return Object.entries(tags).map(([key, value]) => {
    const tags = []
    switch (key) {
      case 'title':
        tags.push(
          `<meta property="og:${key}" content="${value}"  />`, 
          `<title>${value}</title>`
        );
        break;
      case 'type':
      case 'url':
      case 'image':
        tags.push(`<meta property="og:${key}" content="${value}"  />`);
        break;
      case 'description':
        tags.push(
          `<meta property="og:${key}" content="${value}"  />`,
          `<meta name="description" content="${value}" />`
        );
        break;
      case 'favicon': 
        tags.push(
          `<link rel="icon" type="image/x-icon" href="${value}" />`
        );
    }
    return tags;
  }).flat().sort((a, b) => a.localeCompare(b)).join('\n');
}
